import { render } from "./ShortTextCard.vue?vue&type=template&id=5db23d0c&scoped=true"
import script from "./ShortTextCard.vue?vue&type=script&lang=js"
export * from "./ShortTextCard.vue?vue&type=script&lang=js"

import "./ShortTextCard.vue?vue&type=style&index=0&id=5db23d0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db23d0c"]])

export default __exports__